import { useEffect, useState } from 'react'
import toast from 'react-hot-toast'
import {fetchWithAuth} from '../../libs/apiUtils'
import Modal from '../Modal'

interface EditCategoryModalProps {
  isOpen: boolean
  setIsOpen: (open: boolean) => void
  category: { id?: string; groupId?: string; name?: string }
  onSuccess: () => void
}

export default function EditCategoryModal({ 
  isOpen, 
  setIsOpen, 
  category, 
  onSuccess,
}: EditCategoryModalProps) {
  const [name, setName] = useState(category.name || '')
  const [loading, setLoading] = useState(false)

  async function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!name.trim()) return toast.error('Nama kategori tidak boleh kosong')
    if (!category.id) return toast.error('Tidak ada kategori yang dipilih')

    try {
      setLoading(true)
      const res = await fetchWithAuth(`${process.env.REACT_APP_BACKEND_URL}/api/category`, {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: category.id, groupId: category.groupId, name }),
      })

      const data = await res.json()

      if (!res.ok || !data.success) {
        toast.error(data.message || data[0]?.message || 'Error saat memperbarui kategori')
        return
      }

      toast.success('Kategori berhasil diperbarui')
      setIsOpen(false)
      onSuccess()
    } catch (err) {
      toast.error('Kesalahan jaringan, periksa koneksi Anda')
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    if (category.name) setName(category.name)
  }, [category.name])

  return (
    <Modal isOpen={isOpen} onClose={() => setIsOpen(false)}>
      <h3 className="text-xl font-bold text-neutral-800 mb-4">Edit Kategori</h3>
      <form onSubmit={handleSubmit}>
        <div className="mb-6">
          <label htmlFor="edit-cat-name" className="block text-sm font-semibold text-neutral-600 mb-2">
            Nama Kategori
          </label>
          <input
            type="text"
            id="edit-cat-name"
            className="border border-neutral-300 px-4 py-2 rounded-lg w-full focus:ring-2 focus:ring-primary-500 focus:border-primary-500 transition-all outline-none"
            value={name}
            onChange={(e) => setName(e.target.value)}
            autoFocus
          />
        </div>
        <div className="flex justify-end gap-3">
          <button
            type="button"
            className="px-4 py-2 text-neutral-600 font-medium rounded-lg hover:bg-neutral-100 transition-colors"
            onClick={() => setIsOpen(false)}
            disabled={loading}
          >
            Batal
          </button>
          <button
            type="submit"
            className="bg-primary-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-primary-700 active:scale-95 disabled:opacity-50 disabled:active:scale-100 transition-all"
            disabled={loading}
          >
            {loading ? 'Menyimpan...' : 'Simpan Perubahan'}
          </button>
        </div>
      </form>
    </Modal>
  )
}
